import React, { useState } from 'react';
import { ChartBar, ChevronDown } from '@carbon/icons-react';
import Collapsible from '../Collapsible';
import ResidentStats from '../ResidentStats';
import './HomeStatsPanel.css';

/**
 * HomeStatsPanel - panel "Statistika doma" (skupljen po defaultu).
 * Unutra je postojeći ResidentStats widget (popunjenost i struktura stanara).
 */
const HomeStatsPanel = ({ defaultCollapsed = true }) => {
  const [isExpanded, setIsExpanded] = useState(!defaultCollapsed);

  return (
    <section className="adash-panel adash-stats">
      <button
        type="button"
        className={`adash-panel__toggle ${isExpanded ? 'is-expanded' : ''}`}
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        <span className="adash-panel__toggle-left">
          <span className="adash-panel__icon"><ChartBar size={20} /></span>
          <span className="adash-panel__head-text">
            <span className="adash-panel__title">Statistika doma</span>
            <span className="adash-panel__sub">Popunjenost i struktura stanara</span>
          </span>
        </span>
        <ChevronDown
          size={20}
          className={`adash-panel__chevron ${isExpanded ? 'is-expanded' : ''}`}
        />
      </button>
      <Collapsible open={isExpanded}>
        <div className="adash-stats__body">
          <ResidentStats />
        </div>
      </Collapsible>
    </section>
  );
};

export default HomeStatsPanel;
